import { render } from "./OrderCreateSolar.vue?vue&type=template&id=20d178a8"
import script from "./OrderCreateSolar.vue?vue&type=script&lang=js"
export * from "./OrderCreateSolar.vue?vue&type=script&lang=js"

import "./OrderCreateSolar.vue?vue&type=style&index=0&id=20d178a8&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__